import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddToCart from "./StoreComponents/AddToCart";
import ShopNavbar from "./StoreComponents/ShopNavbar";
import StoreFooter from "./StoreComponents/StoreFooter";
import ProductSlider from "./StoreComponents/productSlider/ProductSlider";
import StoreTab from "./StoreComponents/StoreTab";
import LoadingSpinner from "../../components/utils/LoadingSpinner";
import { Helmet } from "react-helmet-async";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { customerProvider } from "../../contexts/CustomerContext";
import { storeInformation } from "../../contexts/StoreInformationContext";
import { domainProvider } from "../../contexts/DomainContext";
import instance from "../../components/utils/CustomerInterceptor";
import axios from "axios";
import { Markup } from "interweave";
import ProductHeader from "./StoreComponents/ProductHeader";
import RelatedProduct from "./StoreComponents/RelatedProduct";
import { toast } from "react-toastify";
import Div from "../../components/utils/Div";

const ProductDetails = () => {
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const [productQuantity, setProductQuantity] = useState(0);
  const [cartQuantity, setCartQuantity] = useState(0);
  const { id } = useParams();
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const { customer } = useContext(customerProvider);
  const { storeDetails } = useContext(storeInformation);
  const storeName = storeDetails?.data?.storeDetails?.store_name
    ? storeDetails?.data?.storeDetails?.store_name
    : window.location.href.split("/")[3];
  const { titleName } = useContext(domainProvider);

  useEffect(() => {
    const getAllProducts = async () => {
      try {
        var res;
        if (customer) {
          res = await instance.get(
            `${process.env.REACT_APP_APIURL}/vendor/store/getbyidstoreproduct/${id}`,
            {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ${customer?.token}`,
              },
            }
          );
        } else {
          res = await axios.get(
            `${process.env.REACT_APP_APIURL}/vendor/store/getbyidstoreproduct/${id}`
          );
        }
        const response = await res.data;
        if (response.status_code === 200 && response.data) {
          setProduct(response.data);
          // changes start
          setProductQuantity(response.data.product_details[0]?.cartQuantity);
          setCartQuantity(
            response.data.product_details[0]?.product_stock -
            response.data.product_details[0]?.cartQuantity
          );
        }
      } catch (err) {
        toast.error("you can't proceed with sample products, please contact with admin to add products");
      }
      setLoading(false);
    };

    getAllProducts();
  }, [id, refresh, customer, storeName]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>Product Details - {titleName}</title>
      </Helmet>

      <ShopNavbar />
      <Div>
        <div className=" mx-auto px-5 py-10 mt-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 ">
            {/* Product Images */}
            <div className="h-full lg:h-[680px] rounded-lg overflow-hidden bg-white p-4">
              <ProductSlider images={product?.images} />
            </div>

            <div className="w-full max-w-2xl mx-auto px-4 py-6 ">
              {/* Product Title */}
              <h1 className="text-4xl font-extrabold text-gray-900 mb-4 leading-tight">
                {selectLanguage === "ar" && product?.product_details?.[0]?.product_name_ar
                  ? product.product_details[0].product_name_ar
                  : product?.product_details?.[0]?.product_name || ""}
              </h1>

              {/* Price */}
              <p className="text-2xl text-green-600 font-bold mb-6">
                {product?.product_details?.[0]?.product_price || 0} ر.س
              </p>

              {/* Description */}
              <div className="prose prose-sm lg:prose-base text-gray-700 mb-8 max-w-none">
                <Markup
                  content={
                    selectLanguage === "ar" &&
                      product?.product_details?.[0]?.product_description_ar
                      ? product.product_details[0].product_description_ar
                      : product?.product_details?.[0]?.product_description || ""
                  }
                />
              </div>

              {/* Add to Cart or Out of Stock */}
              {productQuantity < product?.product_details?.[0]?.product_stock ? (
                <AddToCart
                  id={product?.product_details[0]?.product_id}
                  p_price={product?.product_details[0]?.product_price}
                  colors={product?.colors}
                  tags={product?.tags}
                  sizes={product?.sizes}
                  product={product?.product_details[0]}
                  maxQuantity={cartQuantity}
                />
              ) : (
                <div className="text-center">
                  <p className="text-red-600 text-xl font-semibold mt-6">
                    {selectLanguage === "ar" ? "نفدت المخزون" : "Out of Stock"}
                  </p>
                </div>
              )}
            </div>

          </div>
        </div>

        <RelatedProduct productId={id} />
      </Div>
      <StoreFooter />
    </div>
  );
};

export default ProductDetails;
